module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp1_7042.fd631358.png";